module.exports = __webpack_public_path__ + "img/305.32ebbfe9.jpg";